<div class="login_container">
    <div class="card">

        <div class="logo">
            <img src="{{logoUrl}}"/>
        </div>

        <p>Olá, {{ getUserName() }}.<br/><br/>
        Estamos quase lá 😊<br/>
        Para continuar, por favor crie uma senha segura.</p>

        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <div class="password-group">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" placeholder="Digite aqui sua senha forte" formControlName="password">
                    <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye' " (click)='togglePasswordVisibility()'></i>
                </div>
                
                <ul class="password-criteria">
                    <li [class.valid]="isLengthValid(form.password.value)">
                      <i class="fas" [class.fa-check]="isLengthValid(form.password.value)" [class.fa-times]="!isLengthValid(form.password.value)"></i>
                      Mínimo de 8 caracteres
                    </li>
                    <li [class.valid]="hasUpperCase(form.password.value)">
                      <i class="fas" [class.fa-check]="hasUpperCase(form.password.value)" [class.fa-times]="!hasUpperCase(form.password.value)"></i>
                      Pelo menos uma letra maiúscula
                    </li>
                    <li [class.valid]="hasLowerCase(form.password.value)">
                      <i class="fas" [class.fa-check]="hasLowerCase(form.password.value)" [class.fa-times]="!hasLowerCase(form.password.value)"></i>
                      Pelo menos uma letra minúscula
                    </li>
                    <li [class.valid]="hasNumber(form.password.value)">
                      <i class="fas" [class.fa-check]="hasNumber(form.password.value)" [class.fa-times]="!hasNumber(form.password.value)"></i>
                      Pelo menos um número
                    </li>
                    <li [class.valid]="hasSpecialChar(form.password.value)">
                      <i class="fas" [class.fa-check]="hasSpecialChar(form.password.value)" [class.fa-times]="!hasSpecialChar(form.password.value)"></i>
                      Pelo menos um caractere especial (*@-#$%)
                    </li>
                  </ul>
            </div>
            
            <app-button _label="Entrar" _class="btn-primary"></app-button>

            <div *ngIf="submitted && formHasErrors() && passwordHasErrors()" class="alert alert-danger" role="alert">
                <i class="fas fa-exclamation-triangle"></i>
                <span *ngIf="passwordHasErrors()">O campo senha é obrigatório.</span>
            </div>

            <div *ngIf="invalidLogin" class="alert alert-danger" role="alert">
                <i class="fas fa-exclamation-triangle"></i>
                <span>Ocorreu um erro ao alterar a senha, por favor entre em contato com o administrador do sistema.</span>
            </div>
        </form>
    </div>
</div>